import { getDataBase } from '../db';

export default class LecturaNoSubidaDAL {

    async GetAll() {
        try {

            const loDataBase = await getDataBase();
            const loTransaccion = loDataBase.transaction('lecturas_no_subidas', 'readonly');
            const loAlmacen = loTransaccion.objectStore('lecturas_no_subidas');

            let laResultado = await loAlmacen.getAll();

            // Agregar los nuevos campos
            laResultado = laResultado.map(item => ({
                ...item,
                tnZona: item.tnCodigoUbicacion.slice(0, 4),
                tnUbicacion: item.tnCodigoUbicacion.slice(4),
            }));
            return laResultado;

        } catch (loError) {
            //guardar en los logControllers 
            console.log('Error en GetAll:', loError);
            throw new Error('Error al traer los registros de lectura no subidas.');
        }

    }



    static async GetAll2() {
        try {
            
            const loDataBase = await getDataBase();
            const loTransaccion = loDataBase.transaction('lecturas_no_subidas', 'readonly');
            const loAlmacen = loTransaccion.objectStore('lecturas_no_subidas');

            let laResultado = await loAlmacen.getAll();
            return laResultado;

        } catch (loError) {
            //guardar en los logControllers 
            console.log('Error en GetAll:', loError);
            throw loError;
        }

    }


    static async GetByCliente(tnCliente, tnGeneracionFactura) {
        try {
            const db = await getDataBase();
            const tx = db.transaction('lecturas_no_subidas', 'readonly');
            const store = tx.objectStore('lecturas_no_subidas');
            const laLectura = await store.getAll([tnCliente, tnGeneracionFactura]);
            await tx.done;
            return laLectura;
           
          } catch (error) {
            return [];
          }
    }


    async GetOnly(tnCliente) {
        try {
         
            const loDataBase = await getDataBase();
            const loTransaccion = loDataBase.transaction('lecturas_no_subidas', 'readonly');
            const loAlmacen = loTransaccion.objectStore('lecturas_no_subidas');

            let loResultado = await loAlmacen.getAll();
            let laResultado = [];
            // Agregar los nuevos campos
            for (const element of loResultado) {
                if (element.tnCliente == tnCliente) {
                    laResultado.push({
                        ...element,
                        tnZona: element.tnCodigoUbicacion.slice(0, 4),
                        tnUbicacion: element.tnCodigoUbicacion.slice(4),
                    });
                    
                }
            }

            if (laResultado.length == 0) {
                throw new Error('No se encontraron registros con el cliente indicado.');
            }


            return laResultado;

        } catch (loError) {
            //guardar en los logControllers 
            console.log('Error en GetAll:', loError);
            throw new Error('Error al traer los registros de lectura no subidas.');
        }

    }

    async GetAllNoSubido() {
        try {
            const loDataBase = await getDataBase();
            const loTransaccion = loDataBase.transaction('lecturas_no_subidas', 'readonly');
            const loAlmacen = loTransaccion.objectStore('lecturas_no_subidas');

            let laResultado = (await loAlmacen.getAll())
                .filter(loItem =>
                 [0, 1, 3].includes(loItem.tnEstado)
                );

            await loTransaccion.done;
            return laResultado;

        } catch (loError) {
            //guardar en los logControllers 
            console.log('Error en GetAll:', loError);
            throw new Error(loError);
        }

    }



      /**
       * Cambia el estado de pendienate a subido, de 1 a 2
       */
      cambiarEstadoSubido2 = async () => {   
        try {
     
            const db = await getDataBase();
            const tx = db.transaction('lecturas_no_subidas', 'readwrite');
            const store = tx.objectStore('lecturas_no_subidas');
            const index = store.index('tnEstado');
            const request = index.openCursor(IDBKeyRange.only(1)); // Filtrar estado = 1
    
            request.onsuccess = () => {
                const cursor = request.result;
                if (cursor) {
                    const loItem = cursor.value;
                    loItem.tnEstado = 2;
                    cursor.update(loItem); // Guardar el cambio
                    cursor.continue(); // Continuar con el siguiente
                } else {
                    tx.done; // Finalizar transacción
                    console.log("Estados actualizados correctamente.");
                }
            };
    
            request.onerror = () => {
                console.error("Error al actualizar los estados:", request.error);
            };
    
        } catch (error) {
            console.error('Error en cambiarEstadoSubido:', error);
            throw new Error('Error al cambiar el estado de pendiente a subido.');
        }
    };

    cambiarEstadoSubido = async () => {   
        try {
            const db = await getDataBase();
            const tx = db.transaction('lecturas_no_subidas', 'readwrite');
            const store = tx.objectStore('lecturas_no_subidas');
    
            // Obtener todos los registros
            const registros = await store.getAll();
    
            // Filtrar y actualizar solo los que tengan tnEstado = 1
            registros.forEach((item) => {
                if (item.tnEstado == 0) {
                    item.tnEstado = 2; // Cambiar estado
                    store.put(item); // Guardar cambios
                }
            });
    
            await tx.done;
            console.log("Estados actualizados correctamente.");
    
        } catch (error) {
            console.error('Error en cambiarEstadoSubido:', error);
            throw new Error('Error al cambiar el estado de pendiente a subido.');
        }
    };


    cambiarTodoAPendiente = async () => {   
        try {
            const db = await getDataBase();
            const tx = db.transaction('lecturas_no_subidas', 'readwrite');
            const store = tx.objectStore('lecturas_no_subidas');
    
            // Obtener todos los registros
            const registros = await store.getAll();
    
            // Filtrar y actualizar solo los que tengan tnEstado = 1
            registros.forEach((item) => {
                // if (item.tnEstado == 1 || item.tnEstado == 3) {
                    item.tnEstado = 0; // Cambiar estado
                    store.put(item); // Guardar cambios
                // }
            });
    
            await tx.done;
            console.log("Estados actualizados correctamente.");
    
        } catch (error) {
            console.error('Error en cambiarEstadoSubido:', error);
            throw new Error('Error al cambiar el estado de pendiente a subido.');
        }
    };
    


    /**
     * metodo para cambiar el estado de una lectura
     * @param {*} tnCliente 
     * @param {*} tnGeneracionFactura 
     * @param {*} tnEstado 
     */

    setEstado = async (tnCliente, tnGeneracionFactura, tnEstado) => {
        try {
            const db = await getDataBase();
            const tx = db.transaction('lecturas_no_subidas', 'readwrite');
            const store = tx.objectStore('lecturas_no_subidas');
    
      
            const lectura = await store.get([tnCliente, tnGeneracionFactura]);
    
            if (lectura) {
                lectura.tnEstado = tnEstado;
                await store.put(lectura);
                console.log("Estado actualizado correctamente:", lectura);
            } else {
                throw new Error(`No se encontró el registro con Cliente: ${tnCliente} y Factura: ${tnGeneracionFactura}`);
            }
            await tx.done;
    
        } catch (error) {
            console.error('Error en setEstado:', error);
            throw new Error('Error al cambiar el estado');
        }
    };


    setEstadoArray = async (taLecturas, tnEstado) => {
        try {
            const db = await getDataBase();
            const tx = db.transaction('lecturas_no_subidas', 'readwrite');
            const store = tx.objectStore('lecturas_no_subidas');
              
            // Recorrer el array de clientes y facturas
            for (let i = 0; i < taLecturas.length; i++) {
                const { tnCliente, tnGeneracionFactura } = taLecturas[i];
    
                // Obtener el registro exacto por clave primaria
                const lectura = await store.get([tnCliente, tnGeneracionFactura]);
    
                if (lectura) {
                    lectura.tnEstado = tnEstado;
                    await store.put(lectura);
                    console.log(`Estado actualizado correctamente para Cliente: ${tnCliente}, Factura: ${tnGeneracionFactura}`);
                } else {
                    throw new Error(`No se encontró el registro con Cliente: ${tnCliente} y Factura: ${tnGeneracionFactura}`);
                }
            }
    
            await tx.done;
            console.log("Todos los estados actualizados correctamente.");
    
        } catch (error) {
            console.error('Error en setEstadoArray:', error);
            throw error;
        }
    };
    
    /**
       * Devuelve la cantidad de lecturas pendientes por subir
       * @returns {Promise<number>} Cantidad de lecturas pendientes
    */
    static cantidadPendientes = async () => {
        try {
            const loDataBase = await getDataBase();
            const loTransaccion = loDataBase.transaction('lecturas_no_subidas', 'readonly');
            const loAlmacen = loTransaccion.objectStore('lecturas_no_subidas');

            let laResultado = (await loAlmacen.getAll())
                .filter(loItem =>
                 [0, 1, 3].includes(loItem.tnEstado)
                );

            await loTransaccion.done;
            return laResultado.length;
    
        } catch (error) {
            console.error('Error en cantidadLecturasPendidientes:', error);
            throw new Error('Error al contar las lecturas pendientes.');
        }
    }
    
       
}
    